import { z } from "zod";
import { FullVersionRegex } from "./common.ts";

// One upload publishes one release for one browser major, which is what the
// operator console submits.
export const PublishProfilesSchema = z.object({
	rawBundleId: z.uuid("Must be a valid UUID"),
	browserMajor: z.number().int().positive(),
	bumpType: z.enum(["patch", "minor", "major"]),
	// Escape hatch for the normalize drop guard. Off by default so a provider
	// filename change fails loudly instead of shipping a thinned bundle.
	allowSkipped: z.boolean().optional(),
});
export type PublishProfilesInput = z.infer<typeof PublishProfilesSchema>;

/**
 * Either an explicit full version (147.0.7727.139), the literal string
 * "latest", or omitted to mean "latest". The wrapper script resolves the
 * upstream latest at run time.
 */
export const PublishChromiumSchema = z.object({
	version: z
		.union([z.string().regex(FullVersionRegex), z.literal("latest")])
		.optional(),
});
export type PublishChromiumInput = z.infer<typeof PublishChromiumSchema>;

/**
 * Pin a specific ChromiumBuild row by id. The route path is
 *   POST /api/releases/chromium/:buildId/activate
 * Body is currently empty; a future "reason: string" field can be added
 * here without breaking clients. Kept as an explicit object so we get a
 * stable shape on the wire.
 */
export const ActivateChromiumBuildSchema = z
	.object({
		reason: z.string().max(1024).optional(),
	})
	.optional();
export type ActivateChromiumBuildInput = z.infer<
	typeof ActivateChromiumBuildSchema
>;
